module.exports = __webpack_public_path__ + "static/media/image6.d1195047.jpg";